/* eslint-disable @typescript-eslint/no-explicit-any */
import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'

const EmptyLogic = ({ Wrapper }: any) => {
  const { showcase: copy } = getLocale() || defaultLocale

  return <Wrapper copy={copy} />
}

export default EmptyLogic
